import React from "react";
import { Nav, Navbar, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // Importa el contexto de autenticación

const Sidebar = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout(); // Llama a la función de cerrar sesión
    navigate("/login"); // Redirige al login
  };

  return (
    <Navbar
      bg="dark"
      data-bs-theme="dark"
      expand="lg"
      className="d-flex flex-column vh-100 pt-5"
      style={{ width: "250px" }}
    >
      <Navbar.Brand>Mi App</Navbar.Brand>
      <Nav className="flex-column">
        <Nav.Link as={Link} to="/dashboard">
          Dashboard
        </Nav.Link>
        <Nav.Link as={Link} to="projects">
          Projects
        </Nav.Link>
        <Nav.Link as={Link} to="projects/create">
          Create Project
        </Nav.Link>
        <Nav.Link as={Link} to="project-status">
          Project Status
        </Nav.Link>
        <Nav.Link as={Link} to="kanban">
          Kanban Board
        </Nav.Link>

        <Nav.Link as={Link} to="tests">
          List Test
        </Nav.Link>

        {/*<Nav.Link as={Link} to="projects">
          Projects
        </Nav.Link>*/}

        <Nav.Link as={Link} to="users">
          List Users
        </Nav.Link>
        <Nav.Link as={Link} to="users/create">
          Create User
        </Nav.Link>

        <Nav.Link as={Link} to="defects">
          List defects
        </Nav.Link>
        <Nav.Link as={Link} to="defects/create">
          Create defect
        </Nav.Link>

        {/* Botón de Cerrar Sesión */}
        <Nav.Link
          as="button"
          onClick={handleLogout}
          style={{ cursor: "pointer", color: "red" }}
        >
          Cerrar sesión
        </Nav.Link>
      </Nav>
    </Navbar>
  );
};

export default Sidebar;
